import { ESTATE_PARENT_PLURAL, ESTATE_PLURAL } from "@/services/estateLabels";

export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Nombre de Usuario", size: 15, order: "username" },
	{ name: "Nombre", size: 10, order: "name" },
	{ name: "Email", size: 15, order: "email" },
	{ name: ESTATE_PARENT_PLURAL, size: 10, order: "" },
	{ name: ESTATE_PLURAL, size: 10, order: "" },
	{ name: "Roles", size: 10, order: "" },
	{ name: "Cliente", size: 10, order: "customer_name", only_admin: true },
	{ name: "QR", size: 5, order: "" },
	{ name: "Acción", size: 10, order: "" },
];

export const base_user = {
	customer_id: "",
	customer_name: "",
	email: "",
	id: "",
	name: "",
	roles: [],
	notifications: [],
	permissions: [],
	estates_parents: [],
	estates: [],
	slug: "",
	username: "",
	password: "",
	confirm_password: "",
	access_system: false,
	access_balance: false,
	signature_url: null,
	signature_file_id: null,
	phone: "",
	profiles: [],
	area_id: null,
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};

export const filters = {
	customer_id: "",
	filter_estate_parent_id: "",
	filter_estate_id: "",
	role_id: "",
};
